export const name = 'crmWixCodeSdk' as const
export const namespace = 'crm' as const
